import { removeBlanks } from "../../../../businessLogic/helpers/stringHelpers";
import {
  getParsedRowByIdOrIndex,
  getRelatedRowsByAnagraficaKeys,
  getRowsByCodice,
} from "./rowHelpers";
import {
  isPurePgRow,
  parseLegaleRappNomeCognomeFromItem,
} from "./importConfirmHelpers";
import { normalizeForComparison } from "./creationFlowHelpers";

const pushUnique = (arr, value) => {
  if (value !== "" && arr.filter((x) => x === value).length <= 0) {
    arr.push(value);
  }
};

const isUnknownProvince = (baseProvinceList, province) =>
  baseProvinceList.filter((x) => x.sigla.toLowerCase() === province.toLowerCase()).length <= 0;

const isUnknownComune = (baseComuniList, comune) =>
  baseComuniList.filter((x) => normalizeForComparison(x.nome) === normalizeForComparison(comune)).length <= 0;

export const collectSelectionMappings = ({
  rowIds,
  parsedValues,
  selImportType,
  baseProvinceList,
  baseComuniList,
}) => {
  const arrProf = [];
  const arrTipoIdent = [];
  const arrTipoDoc = [];
  const arrProvince = [];
  const arrComuni = [];

  for (let i = 0; i < rowIds.length; i++) {
    const rowItem = rowIds[i];
    const item = getParsedRowByIdOrIndex(parsedValues, rowItem);

    if (!item || !Array.isArray(item)) {
      continue;
    }

    const cf = removeBlanks(item[15] || "");
    const pIva = removeBlanks(item[9] || "");
    const codice = item[0] || "";

    const relatedByKeys = getRelatedRowsByAnagraficaKeys({
      parsedValues,
      cf,
      pIva,
    });
    // Includi anche le righe con lo stesso codice (es. legale rappresentante
    // con CF diverso dal soggetto PG) per allinearsi a getRowsByCodice usato
    // in fase di elaborazione.
    const relatedByCodice = getRowsByCodice(parsedValues, codice);
    const related = [...relatedByKeys];
    for (const row of relatedByCodice) {
      if (!related.includes(row)) {
        related.push(row);
      }
    }

    for (let m = 0; m < related.length; m++) {
      const subItem = related[m];

      if (!subItem || !Array.isArray(subItem)) {
        continue;
      }

      const addrComune = (subItem[11] || "").trim();
      const addrProvincia = (subItem[12] || "").trim();

      if (selImportType === "aricdesktop") {
        const rappAddrComune = (subItem[39] || "").trim();
        const rappAddrProvincia = (subItem[40] || "").trim();

        const identCfProf = (subItem[21] || "").trim();
        const identTipo = (subItem[23] || "").trim();
        const identDocTipo = (subItem[24] || "").trim();

        const identCfProf2 = (subItem[43] || "").trim();
        const identTipo2 = (subItem[45] || "").trim();
        const identDocTipo2 = (subItem[46] || "").trim();

        pushUnique(arrTipoIdent, identTipo);
        pushUnique(arrTipoIdent, identTipo2);
        pushUnique(arrTipoDoc, identDocTipo);
        pushUnique(arrTipoDoc, identDocTipo2);

        if (identCfProf !== "" && arrProf.filter((x) => x === identCfProf).length <= 0) {
          if (arrProf.length <= 0) {
            arrProf.push(identCfProf);
          }
        }

        if (identCfProf2 !== "" && arrProf.filter((x) => x === identCfProf2).length <= 0) {
          if (arrProf.length <= 0) {
            arrProf.push(identCfProf2);
          }
        }

        if (
          addrProvincia !== "" &&
          addrProvincia !== "  " &&
          addrProvincia !== "EE" &&
          arrProvince.filter((x) => x === addrProvincia).length <= 0 &&
          isUnknownProvince(baseProvinceList, addrProvincia)
        ) {
          arrProvince.push(addrProvincia);
        }

        if (
          addrComune !== "" &&
          addrProvincia !== "EE" &&
          arrComuni.filter((x) => x === addrComune).length <= 0 &&
          isUnknownComune(baseComuniList, addrComune)
        ) {
          arrComuni.push(addrComune);
        }

        if (
          rappAddrProvincia !== "" &&
          rappAddrProvincia !== "  " &&
          rappAddrProvincia !== "EE" &&
          arrProvince.filter((x) => x === rappAddrProvincia).length <= 0 &&
          isUnknownProvince(baseProvinceList, rappAddrProvincia)
        ) {
          arrProvince.push(rappAddrProvincia);
        }

        if (
          rappAddrComune !== "" &&
          rappAddrProvincia !== "EE" &&
          arrComuni.filter((x) => x === rappAddrComune).length <= 0 &&
          isUnknownComune(baseComuniList, rappAddrComune)
        ) {
          arrComuni.push(rappAddrComune);
        }
      } else if (selImportType === "multi") {
        const rappAddrComune = (subItem[26] || "").trim();
        const rappAddrProvincia = (subItem[27] || "").trim();

        if (
          addrProvincia !== "" &&
          addrProvincia !== "  " &&
          addrProvincia !== "EE" &&
          arrProvince.filter((x) => x === addrProvincia).length <= 0 &&
          isUnknownProvince(baseProvinceList, addrProvincia)
        ) {
          arrProvince.push(addrProvincia);
        }

        if (
          addrComune !== "" &&
          addrProvincia !== "EE" &&
          arrComuni.filter((x) => x === addrComune).length <= 0 &&
          isUnknownComune(baseComuniList, addrComune)
        ) {
          arrComuni.push(addrComune);
        }

        if (
          rappAddrProvincia !== "" &&
          rappAddrProvincia !== "  " &&
          rappAddrProvincia !== "EE" &&
          arrProvince.filter((x) => x === rappAddrProvincia).length <= 0 &&
          isUnknownProvince(baseProvinceList, rappAddrProvincia)
        ) {
          arrProvince.push(rappAddrProvincia);
        }

        if (
          rappAddrComune !== "" &&
          rappAddrProvincia !== "EE" &&
          arrComuni.filter((x) => x === rappAddrComune).length <= 0 &&
          isUnknownComune(baseComuniList, rappAddrComune)
        ) {
          arrComuni.push(rappAddrComune);
        }
      }
    }
  }

  if (rowIds.length > 0 && arrProf.length === 0) {
    arrProf.push("Professionista che identifica");
  }

  return {
    arrProf,
    arrTipoIdent,
    arrTipoDoc,
    arrProvince,
    arrComuni,
  };
};

export const checkLegaleRappStatusForRows = async ({
  importableRows,
  parsedValues,
  importType,
  fetchAnagByCf,
  tenantId,
  isAlphaNumericFn,
  selectedRowIds = [],
}) => {
  const result = importableRows.map((row) => ({ ...row }));

  // Costruisce un insieme delle righe selezionate per la ricerca rapida
  const selectedRows = selectedRowIds
    .map((id) => importableRows.find((r) => r.id === id))
    .filter(Boolean);

  for (let i = 0; i < result.length; i++) {
    const row = result[i];
    const item = getParsedRowByIdOrIndex(parsedValues, row.id);
    const relatedRows = getRowsByCodice(parsedValues, item[0]);
    if (!item || !Array.isArray(item)) {
      result[i] = { ...row, legaleRappStatus: "red", legaleRappFascicolo: null };
      continue;
    }

    if (!row.isPg) {
      result[i] = { ...row, legaleRappStatus: null, legaleRappFascicolo: null };
      continue;
    }

    // Ditta individuale: il LR viene creato automaticamente dai dati della riga → sempre "trovato"
    const diCf = (item[15] || "").trim();
    const diPIva = (item[9] || "").trim();
    const isDI =
      diCf !== "" &&
      diPIva !== "" &&
      diCf !== diPIva &&
      diCf.length === 16 &&
      isAlphaNumericFn &&
      isAlphaNumericFn(diCf);

    if (isDI) {
      result[i] = { ...row, legaleRappStatus: "green", legaleRappFascicolo: null };
      continue;
    }

    // Primo step: campo 42 (item[41]) = CF del legale rappresentante per PG pura
    // Il CF può trovarsi in una riga correlata con lo stesso codice (item[0]), non necessariamente nella riga principale    
    let rappCf = "";
    for (let r = 0; r < relatedRows.length; r++) {
      const candidate = importType === "aricdesktop"
        ? (relatedRows[r][41] || "").trimStart().trimEnd()
        : (relatedRows[r][28] || "").trimStart().trimEnd();
      if (candidate !== "") {
        rappCf = candidate;
        break;
      }
    }

    if (rappCf) {
      result[i] = { ...row, legaleRappStatus: "green", legaleRappFascicolo: null };
      continue;
    }

    // Secondo step: campo 30 (item[29]) = cognome e nome del legale rappresentante    
    const lrNomeCognome = (item[29] || "").trim() || relatedRows.map((r) => (r[29] || "").trim()).find((v) => v !== "");
    if (lrNomeCognome) {
      // Cerca nelle righe selezionate per denominazione → verde
      const matchInSelected = selectedRows.find(
        (r) => (r.denominazione || "").trim().toLowerCase() === lrNomeCognome.toLowerCase()
      );
      if (matchInSelected) {
        result[i] = { ...row, legaleRappStatus: "green", legaleRappFascicolo: matchInSelected.denominazione };
        continue;
      }

      // Campo 16 non è un CF fiscale di persona fisica: cerca nel DB per nome e cognome
      const parsed = parseLegaleRappNomeCognomeFromItem(relatedRows.find((r) => (r[29] || "").trim() === lrNomeCognome));
      if (parsed) {
        try {
          const response = await fetchAnagByCf({
            tenantId,
            cf: "%%",
            cognome: "%" + parsed.cognome + "%",
            nome: "%" + parsed.nome + "%",
          });

          const anagrafiche = response?.data?.data?.anagrafica ?? [];

          if (anagrafiche.length === 1) {
            result[i] = { ...row, legaleRappStatus: "green", legaleRappFascicolo: null };
          } else if (anagrafiche.length === 0) {
            // Il LR non è nel DB: cerca tra tutte le righe importabili → giallo
            const matchingImportRow = importableRows.find(
              (r) => (r.denominazione || "").trim().toLowerCase() === lrNomeCognome.toLowerCase()
            );
            result[i] = {
              ...row,
              legaleRappStatus: matchingImportRow ? "yellow" : "red",
              legaleRappFascicolo: matchingImportRow ? matchingImportRow.denominazione : null,
            };
          } else {
            // Più di un risultato: non facciamo nulla
            result[i] = { ...row, legaleRappStatus: null, legaleRappFascicolo: null };
          }
        } catch {
          result[i] = { ...row, legaleRappStatus: "red", legaleRappFascicolo: null };
        }
        continue;
      }
    }    

    if(rappCf){
      // Cerca il CF del LR tra le righe selezionate → verde
      const matchInSelectedByCf = selectedRows.find(
        (r) => (r.cf || "").trimStart().trimEnd() === rappCf
      );
      if (matchInSelectedByCf) {
        result[i] = {
          ...row,
          legaleRappStatus: "green",
          legaleRappFascicolo: matchInSelectedByCf.denominazione || rappCf,
        };
        continue;
      }
  
      // Cerca il CF del LR tra tutte le righe importabili → giallo
      const matchInImportable = importableRows.find(
        (r) => !r.isPg && (r.cf || "").trimStart().trimEnd() === rappCf
      );
      if (matchInImportable) {
        result[i] = {
          ...row,
          legaleRappStatus: "yellow",
          legaleRappFascicolo: matchInImportable.denominazione || rappCf,
        };
        continue;
      }    
    }

    result[i] = { ...row, legaleRappStatus: "red", legaleRappFascicolo: null };
  }

    

  return result;
};

export const validatePgLegaleRappSelection = async ({
  rowIds,
  parsedValues,
  isAlphaNumericFn,
  fetchAnagByCf,
  tenantId,
}) => {
  const results = [];

  for (let i = 0; i < rowIds.length; i++) {
    const item = getParsedRowByIdOrIndex(parsedValues, rowIds[i]);
    if (!item || !Array.isArray(item)) continue;

    if (!isPurePgRow(item, isAlphaNumericFn)) continue;

    const denominazione = (item[1] || "").trim();
    const parsed = parseLegaleRappNomeCognomeFromItem(item);

    if (!parsed) {
      results.push({ denominazione, status: "not_found" });
      continue;
    }

    const response = await fetchAnagByCf({
      tenantId,
      cf: "%%",
      cognome: "%" + parsed.cognome + "%",
      nome: "%" + parsed.nome + "%",
    });

    const count = response?.data?.data?.anagrafica?.length ?? 0;

    if (count === 0) {
      results.push({ denominazione, status: "not_found" });
    } else if (count === 1) {
      results.push({
        denominazione,
        status: "found",
        anagraficaId: response.data.data.anagrafica[0].Id,
      });
    } else {
      results.push({ denominazione, status: "multiple" });
    }
  }

  return results;
};
